import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import App from './App';
import './darkThemeOverrides.css';
import { initializeAppearance } from './appearanceRuntime';
import { initializeTheme } from './themeRuntime';
import { captureAttributionFromWindow } from './marketingAttribution';

initializeTheme();
initializeAppearance();
// Capture first-touch partner/UTM before React Router redirects (e.g. /website → /).
captureAttributionFromWindow();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
